import { Routes } from '@angular/router';
import { authGuard } from './services/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'eventos',
    loadChildren: () => import('./eventos/eventos.routes').then((module) => module.EVENTOS_ROUTES)
  },
  {
    path: 'evento/:nome/:id',
    redirectTo: 'eventos/evento/:nome/:id',
    pathMatch: 'full'
  },
  {
    path: 'evento/lista-inscritos/:nome/:id',
    redirectTo: 'eventos/evento/lista-inscritos/:nome/:id',
    pathMatch: 'full'
  },
  {
    path: 'evento/fazer-inscricao/:nome/:id',
    redirectTo: 'eventos/evento/fazer-inscricao/:nome/:id',
    pathMatch: 'full'
  },
  {
    path: 'entrar-conta',
    redirectTo: 'eventos/entrar-conta',
    pathMatch: 'full'
  },
  {
    path: 'criar-conta',
    redirectTo: 'eventos/criar-conta',
    pathMatch: 'full'
  },
  {
    path: 'redefinir-senha-conta',
    redirectTo: 'eventos/redefinir-senha-conta',
    pathMatch: 'full'
  },
  {
    path: 'nova-senha/:code',
    redirectTo: 'eventos/nova-senha/:code',
    pathMatch: 'full'
  },
  {
    path: 'criar-evento',
    redirectTo: 'eventos/criar-evento',
    pathMatch: 'full'
  },
  {
    path: 'criar-evento/form/:tipo',
    redirectTo: 'eventos/criar-evento/form/:tipo',
    pathMatch: 'full'
  },
  {
    path: 'user',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/user/user-shell.component').then((module) => module.UserShellComponent),
    children: [
      {
        path: 'meus-dados',
        loadComponent: () => import('./pages/user/meu-perfil/meu-perfil.component').then((module) => module.MeuPerfilComponent)
      },
      {
        path: 'meus-pedidos',
        loadComponent: () => import('./pages/user/meus-pedidos/meus-pedidos.component').then((module) => module.MeusPedidosComponent)
      },
      {
        path: 'meus-eventos',
        loadComponent: () => import('./pages/user/meus-eventos/meus-eventos.component').then((module) => module.MeusEventosComponent)
      },
      {
        path: 'painel',
        loadChildren: () => import('./pages/user/painel/painel.routes').then((module) => module.PAINEL_ROUTES)
      },
      {
        path: '',
        redirectTo: 'painel',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'evento/fazer-inscricao-sem-login/:nome/:id',
    redirectTo: 'eventos/evento/fazer-inscricao-sem-login/:nome/:id',
    pathMatch: 'full'
  },
  {
    path: 'finalizar-integracao/:nome/:chave',
    redirectTo: 'eventos/finalizar-integracao/:nome/:chave',
    pathMatch: 'full'
  },
  {
    path: 'evento/ranking/:nome/:id',
    redirectTo: 'eventos/evento/ranking/:nome/:id',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('./public/app.module').then((module) => module.AppModule)
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];
